import script from "./Academic_Result.vue?vue&type=script&setup=true&lang=js"
export * from "./Academic_Result.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__